import {
  FETCH_WELD_HEALTH,
  FETCH_WELD_HEALTH_SUCCESS,
  FETCH_WELD_HEALTH_FAILURE,
  FETCH_WELD_ANALYTICS_BUNDLE,
  FETCH_WELD_ANALYTICS_BUNDLE_SUCCESS,
  FETCH_WELD_ANALYTICS_BUNDLE_FAILURE,
  FETCH_WELD_ANALYTICS_BUNDLE_CANCELLED,
  FETCH_WELD_ANALYTICS_PRODUCTION,
  FETCH_WELD_ANALYTICS_PRODUCTION_SUCCESS,
  FETCH_WELD_ANALYTICS_PRODUCTION_FAILURE,
  FETCH_WELD_ANALYTICS_PRODUCTION_CANCELLED,
  FETCH_WELD_DETAIL,
  FETCH_WELD_DETAIL_SUCCESS,
  FETCH_WELD_DETAIL_FAILURE,
  TRIGGER_WELD_PIPELINE,
  TRIGGER_WELD_PIPELINE_SUCCESS,
  TRIGGER_WELD_PIPELINE_FAILURE,
  CLEAR_WELD_ANALYTICS,
  FETCH_INSPECTION_DATA,
  FETCH_INSPECTION_DATA_SUCCESS,
  FETCH_INSPECTION_DATA_FAILURE,
  FETCH_INSPECTION_PASSES,
  FETCH_INSPECTION_PASSES_SUCCESS,
  FETCH_INSPECTION_PASSES_FAILURE,
  LIVE_CHECK_ANOMALY,
  LIVE_CHECK_ANOMALY_SUCCESS,
  LIVE_CHECK_ANOMALY_FAILURE,
  LIVE_CHECK_INDICATION,
  LIVE_CHECK_INDICATION_SUCCESS,
  LIVE_CHECK_INDICATION_FAILURE,
  LIVE_PREDICT,
  LIVE_PREDICT_SUCCESS,
  LIVE_PREDICT_FAILURE,
  LIVE_SCORE_PASS,
  LIVE_SCORE_PASS_SUCCESS,
  LIVE_SCORE_PASS_FAILURE,
  FETCH_PIPELINE_EXECUTIONS,
  FETCH_PIPELINE_EXECUTIONS_SUCCESS,
  FETCH_PIPELINE_EXECUTIONS_FAILURE,
} from './types';

export const fetchWeldHealth = () => ({ type: FETCH_WELD_HEALTH });
export const fetchWeldHealthSuccess = (payload) => ({ type: FETCH_WELD_HEALTH_SUCCESS, payload });
export const fetchWeldHealthFailure = (error) => ({ type: FETCH_WELD_HEALTH_FAILURE, error });

export const fetchWeldAnalyticsBundle = (payload) => ({
  type: FETCH_WELD_ANALYTICS_BUNDLE,
  payload,
});
export const fetchWeldAnalyticsBundleSuccess = (payload) => ({
  type: FETCH_WELD_ANALYTICS_BUNDLE_SUCCESS,
  payload,
});
export const fetchWeldAnalyticsBundleFailure = (error, meta) => ({
  type: FETCH_WELD_ANALYTICS_BUNDLE_FAILURE,
  error,
  meta,
});
export const fetchWeldAnalyticsBundleCancelled = (meta) => ({
  type: FETCH_WELD_ANALYTICS_BUNDLE_CANCELLED,
  meta,
});

export const fetchWeldAnalyticsProduction = (payload) => ({
  type: FETCH_WELD_ANALYTICS_PRODUCTION,
  payload,
});
export const fetchWeldAnalyticsProductionSuccess = (payload) => ({
  type: FETCH_WELD_ANALYTICS_PRODUCTION_SUCCESS,
  payload,
});
export const fetchWeldAnalyticsProductionFailure = (error, meta) => ({
  type: FETCH_WELD_ANALYTICS_PRODUCTION_FAILURE,
  error,
  meta,
});
export const fetchWeldAnalyticsProductionCancelled = (meta) => ({
  type: FETCH_WELD_ANALYTICS_PRODUCTION_CANCELLED,
  meta,
});

export const fetchWeldDetail = (payload) => ({ type: FETCH_WELD_DETAIL, payload });
export const fetchWeldDetailSuccess = (payload) => ({ type: FETCH_WELD_DETAIL_SUCCESS, payload });
export const fetchWeldDetailFailure = (error) => ({ type: FETCH_WELD_DETAIL_FAILURE, error });

export const triggerWeldPipeline = (payload) => ({ type: TRIGGER_WELD_PIPELINE, payload });
export const triggerWeldPipelineSuccess = (payload) => ({
  type: TRIGGER_WELD_PIPELINE_SUCCESS,
  payload,
});
export const triggerWeldPipelineFailure = (error) => ({
  type: TRIGGER_WELD_PIPELINE_FAILURE,
  error,
});

export const clearWeldAnalytics = () => ({ type: CLEAR_WELD_ANALYTICS });

export const fetchInspectionData = (payload) => ({ type: FETCH_INSPECTION_DATA, payload });
export const fetchInspectionDataSuccess = (payload) => ({
  type: FETCH_INSPECTION_DATA_SUCCESS,
  payload,
});
export const fetchInspectionDataFailure = (error) => ({
  type: FETCH_INSPECTION_DATA_FAILURE,
  error,
});

export const fetchInspectionPasses = (payload) => ({ type: FETCH_INSPECTION_PASSES, payload });
export const fetchInspectionPassesSuccess = (payload) => ({
  type: FETCH_INSPECTION_PASSES_SUCCESS,
  payload,
});
export const fetchInspectionPassesFailure = (error) => ({
  type: FETCH_INSPECTION_PASSES_FAILURE,
  error,
});

export const liveCheckAnomaly = (payload) => ({ type: LIVE_CHECK_ANOMALY, payload });
export const liveCheckAnomalySuccess = (payload) => ({
  type: LIVE_CHECK_ANOMALY_SUCCESS,
  payload,
});
export const liveCheckAnomalyFailure = (error, meta) => ({
  type: LIVE_CHECK_ANOMALY_FAILURE,
  error,
  meta,
});

export const liveCheckIndication = (payload) => ({ type: LIVE_CHECK_INDICATION, payload });
export const liveCheckIndicationSuccess = (payload) => ({
  type: LIVE_CHECK_INDICATION_SUCCESS,
  payload,
});
export const liveCheckIndicationFailure = (error, meta) => ({
  type: LIVE_CHECK_INDICATION_FAILURE,
  error,
  meta,
});

export const livePredict = (payload) => ({ type: LIVE_PREDICT, payload });
export const livePredictSuccess = (payload) => ({ type: LIVE_PREDICT_SUCCESS, payload });
export const livePredictFailure = (error, meta) => ({
  type: LIVE_PREDICT_FAILURE,
  error,
  meta,
});

export const liveScorePass = (payload) => ({ type: LIVE_SCORE_PASS, payload });
export const liveScorePassSuccess = (payload) => ({ type: LIVE_SCORE_PASS_SUCCESS, payload });
export const liveScorePassFailure = (error, meta) => ({
  type: LIVE_SCORE_PASS_FAILURE,
  error,
  meta,
});

export const fetchPipelineExecutions = (payload) => ({
  type: FETCH_PIPELINE_EXECUTIONS,
  payload,
});
export const fetchPipelineExecutionsSuccess = (payload) => ({
  type: FETCH_PIPELINE_EXECUTIONS_SUCCESS,
  payload,
});
export const fetchPipelineExecutionsFailure = (error) => ({
  type: FETCH_PIPELINE_EXECUTIONS_FAILURE,
  error,
});
